import { type UseMutationResult, useMutation, useQueryClient } from 'react-query';
import { toast } from 'react-toastify';
import ToastComponent from '../../components/toast';
import { DisbursementService } from '@wealthlane/api-services/wealthlane-award-settlement-service';
import { TableError } from '../../types/common';

const usePutDisbursement = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  onClose?: () => void,
  onError?: (message: string, errors: TableError[]) => void
): UseMutationResult<any, unknown, any, unknown> => {
  const queryClient = useQueryClient();

  return useMutation(
    async (payload: any) => {
      return await handleRequest(
        DisbursementService.putApiAwardSettlementApiAppDisbursementDisbursement(payload)
      );
    },
    {
      onSuccess: async (response: any) => {
        if (response !== null && response?.success !== false) {
          toast.success(
            <ToastComponent label='Success' message={`Disbursement updated successfully.`} />
          );
          await queryClient.invalidateQueries('getDisbursementDetails');
        } else {
          throw {
            message: response?.message || 'Update failed',
            errors: response?.errors || [],
            error: new Error(),
          };
        }
        onClose && onClose();
      },
      onError: (err: any) => {
        console.log('error', err);
        onError && onError(err?.message, err?.errors);
        onClose && onClose();
      },
    }
  );
};

export default usePutDisbursement;
